<unity-page-container contentHeader="Client Expenses" [contentHeaderSecondary]="$contentHeaderSecondary()" [isLoading]="false">
  <ng-container notifications />

  <ng-container page-return> <unity-action-shared [action]="$returnToAgreementAction()" /></ng-container>

  <ng-container actions>
    <unity-action-shared [action]="$createClientExpenseAction()" />
  </ng-container>

  <ng-container stats>
    @let agreementStats = $agreementStats();
    <unity-card-item-count-summary-shared
      displayName="Total Client Expenses Count"
      [itemCount]="agreementStats?.total_client_expenses_count"
      [isLoading]="agreementStatsResource.isLoading()" />
    <unity-card-funds-expensed-summary-shared [agreement]="agreementStats" [isLoading]="agreementStatsResource.isLoading()" />
  </ng-container>

  <unity-grid-client-expense-shared [agreementId]="$agreementId()" />
</unity-page-container>
